import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

const ERROR_HANDLED_PARAM_NAME = 'errorHandled';

@Injectable({ providedIn: 'root' })
export class TokenReceiveErrorInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((errResponse: unknown) => {
        if (errResponse instanceof HttpErrorResponse) {
          switch (errResponse.status) {
            case 500:
              if (this.isNeedRepeatRequest(request)) {
                const cloneRequest = request.clone();
                // помечаем повторный запрос, чтобы не ддосить бэк если он повторно не ответил
                cloneRequest.params.append(ERROR_HANDLED_PARAM_NAME, true);

                return next.handle(cloneRequest);
              }

              break;
          }
        }

        return throwError(() => errResponse);
      }),
    );
  }

  private isNeedRepeatRequest(request: HttpRequest<any>): boolean {
    return (
      request.url.includes('oauth/token') && request.method === 'POST' && !request.params.has(ERROR_HANDLED_PARAM_NAME)
    );
  }
}
